module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "tracklist"
  }, [_h('div', {
    staticClass: "row",
    attrs: {
      "id": "filter"
    }
  }, [_h('div', {
    staticClass: "col-md-12"
  }, [_h('form', [_h('div', {
    staticClass: "form-group orderby"
  }, [_m(0), " ", _h('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (orderBy),
      expression: "orderBy"
    }],
    staticClass: "custom-select",
    attrs: {
      "id": "orderBy"
    },
    on: {
      "change": function($event) {
        orderBy = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          return "_value" in o ? o._value : o.value
        })[0]
      }
    }
  }, [_m(1), " ", _m(2), " ", _m(3), " ", _m(4)])]), " ", _h('div', {
    staticClass: "form-group filter filter--type"
  }, ["\n            Platform:\n            ", _l((availableFiltersPlattform), function(filter) {
    return [_h('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (filterTrackPlattform),
        expression: "filterTrackPlattform"
      }],
      attrs: {
        "type": "checkbox",
        "id": filter
      },
      domProps: {
        "value": filter,
        "checked": Array.isArray(filterTrackPlattform) ? _i(filterTrackPlattform, filter) > -1 : _q(filterTrackPlattform, true)
      },
      on: {
        "change": function($event) {
          var $$a = filterTrackPlattform,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = filter,
              $$i = _i($$a, $$v);
            if ($$c) {
              $$i < 0 && (filterTrackPlattform = $$a.concat($$v))
            } else {
              $$i > -1 && (filterTrackPlattform = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            filterTrackPlattform = $$c
          }
        }
      }
    }), " ", _h('label', {
      attrs: {
        "for": filter
      }
    }, [_s(filter)])]
  })]), " ", _h('div', {
    staticClass: "form-group filter filter--type"
  }, ["\n            Type:\n            ", _l((availableFiltersType), function(filter) {
    return [_h('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (filterTrackTypes),
        expression: "filterTrackTypes"
      }],
      attrs: {
        "type": "checkbox",
        "id": filter
      },
      domProps: {
        "value": filter,
        "checked": Array.isArray(filterTrackTypes) ? _i(filterTrackTypes, filter) > -1 : _q(filterTrackTypes, true)
      },
      on: {
        "change": function($event) {
          var $$a = filterTrackTypes,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = filter,
              $$i = _i($$a, $$v);
            if ($$c) {
              $$i < 0 && (filterTrackTypes = $$a.concat($$v))
            } else {
              $$i > -1 && (filterTrackTypes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            filterTrackTypes = $$c
          }
        }
      }
    }), " ", _h('label', {
      attrs: {
        "for": filter
      }
    }, [_s(filter)])]
  })]), " ", _h('div', {
    staticClass: "form-group filter filter--style"
  }, ["\n            Style:\n            ", _l((availableFiltersStyle), function(filter) {
    return [_h('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (filterTrackStyles),
        expression: "filterTrackStyles"
      }],
      attrs: {
        "type": "checkbox",
        "id": filter
      },
      domProps: {
        "value": filter,
        "checked": Array.isArray(filterTrackStyles) ? _i(filterTrackStyles, filter) > -1 : _q(filterTrackStyles, true)
      },
      on: {
        "change": function($event) {
          var $$a = filterTrackStyles,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = filter,
              $$i = _i($$a, $$v);
            if ($$c) {
              $$i < 0 && (filterTrackStyles = $$a.concat($$v))
            } else {
              $$i > -1 && (filterTrackStyles = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            filterTrackStyles = $$c
          }
        }
      }
    }), " ", _h('label', {
      attrs: {
        "for": filter
      }
    }, [_s(filter)])]
  })]), " ", _h('div', {
    staticClass: "form-group filter filter--length"
  }, ["\n            Length:\n            ", _l((availableFiltersLengths), function(filter) {
    return [_h('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (filterTrackLengths),
        expression: "filterTrackLengths"
      }],
      attrs: {
        "type": "checkbox",
        "id": filter
      },
      domProps: {
        "value": filter,
        "checked": Array.isArray(filterTrackLengths) ? _i(filterTrackLengths, filter) > -1 : _q(filterTrackLengths, true)
      },
      on: {
        "change": function($event) {
          var $$a = filterTrackLengths,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = filter,
              $$i = _i($$a, $$v);
            if ($$c) {
              $$i < 0 && (filterTrackLengths = $$a.concat($$v))
            } else {
              $$i > -1 && (filterTrackLengths = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            filterTrackLengths = $$c
          }
        }
      }
    }), " ", _h('label', {
      attrs: {
        "for": filter
      }
    }, [_s(filter)])]
  })])])])]), " ", _h('div', {
    staticClass: "row"
  }, [_h('div', {
    staticClass: "col-md-12"
  }, [(loadingTracks) ? _h('div', {
    staticClass: "alert alert-info"
  }, [_m(5), "  This may take a while\n       "]) : _e()])]), " ", _h('div', {
    staticClass: "row",
    attrs: {
      "id": "tracklist"
    }
  }, [_l((tracks), function(track) {
    return _h('div', {
      staticClass: "col-md-3 col-xs-6"
    }, [_h('div', {
      staticClass: "card thumbnail"
    }, [_h('div', {
      staticClass: "hover-btn"
    }, [_h('a', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "href": 'https://players.turbo.trackmania.com' + track.url,
        "target": "_blank"
      }
    }, ["Open"]), " ", _h('a', {
      staticClass: " btn btn-primary   btn-sm",
      attrs: {
        "href": 'https://players.turbo.trackmania.com/' + track.plattform + '/maps/favorites/' + track.url.split('/').pop() + '/add',
        "target": "_blank"
      }
    }, ["Add to Favorites"])]), " ", _h('img', {
      staticClass: "card-img-top img-fluid",
      attrs: {
        "src": track.img,
        "alt": track.name
      }
    }), " ", _h('div', {
      staticClass: "card-block text-xs-center"
    }, [_h('h4', {
      staticClass: "card-title"
    }, [_s(track.name) + " – ", _h('span', {
      staticClass: "tag tag-success"
    }, [_s(track.plattform)])]), " ", _h('h6', {
      staticClass: "card-subtitle text-muted"
    }, ["by " + _s(track.author)]), " ", _h('p', [_h('span', {
      staticClass: "tag tag-info"
    }, [_s(track.type)]), " ", _h('span', {
      staticClass: "tag tag-info"
    }, [_s(track.style)]), " ", _h('span', {
      staticClass: "tag tag-info"
    }, [_s(track.length)])]), " ", _h('table', {
      staticClass: "table table-sm"
    }, [_h('tbody', [_h('tr', [_m(6, true), " ", _h('td', [_s(track.plays)])]), " ", _h('tr', [_m(7, true), " ", _h('td', [_s(track.playsdiff)])]), " ", _h('tr', [_m(8, true), " ", _h('td', [_s(track.ratings)])]), " ", _h('tr', [_m(9, true), " ", _h('td', [_s(track.rating) + " / 5"])])])])])])])
  }), " ", _h('infinite-loading', {
    ref: "infiniteLoading",
    attrs: {
      "on-infinite": onInfinite
    }
  })])])
}},staticRenderFns: [function (){with(this) {
  return _h('label', {
    attrs: {
      "for": "orderBy"
    }
  }, ["Order by: "])
}},function (){with(this) {
  return _h('option', {
    attrs: {
      "value": "F"
    }
  }, ["Most Played (ever)"])
}},function (){with(this) {
  return _h('option', {
    attrs: {
      "value": "I"
    }
  }, ["Most Played (recently)"])
}},function (){with(this) {
  return _h('option', {
    attrs: {
      "value": "G"
    }
  }, ["Most Ratings"])
}},function (){with(this) {
  return _h('option', {
    attrs: {
      "value": "H"
    }
  }, ["Best Rating"])
}},function (){with(this) {
  return _h('strong', ["Loading Track Data"])
}},function (){with(this) {
  return _h('th', {
    attrs: {
      "scope": "row"
    }
  }, ["Plays"])
}},function (){with(this) {
  return _h('th', {
    attrs: {
      "scope": "row"
    }
  }, ["Recent"])
}},function (){with(this) {
  return _h('th', {
    attrs: {
      "scope": "row"
    }
  }, ["Votes"])
}},function (){with(this) {
  return _h('th', {
    attrs: {
      "scope": "row"
    }
  }, ["Rating"])
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-500db6fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracklist.vue
// module id = 10
// module chunks = 1